<template>
  <div class="loading" ref="loading">
    <div class="lds-ring">
      <div :style="`border: 8px solid ${chatbotColors.sentMessage.bg}; border-color: ${chatbotColors.sentMessage.bg} transparent transparent transparent;`"></div>
      <div :style="`border: 8px solid ${chatbotColors.sentMessage.bg}; border-color: ${chatbotColors.sentMessage.bg} transparent transparent transparent;`"></div>
      <div :style="`border: 8px solid ${chatbotColors.sentMessage.bg}; border-color: ${chatbotColors.sentMessage.bg} transparent transparent transparent;`"></div>
    </div>
    <span class="buscando">Buscando resultados...</span>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    chatbotColors: {
      type: Object,
      required: true
    },
  },
}
</script>

<style scoped lang="scss">
	.loading {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
    flex-direction: column;
	}
	.lds-ring {
		display: inline-block;
		position: relative;
		width: 60px;
		height: 60px;
	}
	.lds-ring div {
		box-sizing: border-box;
		display: block;
		position: absolute;
		width: 44px;
		height: 44px;
		margin: 8px;
		border-radius: 50%;
		animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	}
	.lds-ring div:nth-child(1) {
		animation-delay: -0.45s;
	}
	.lds-ring div:nth-child(2) {
		animation-delay: -0.3s;
	}
	.lds-ring div:nth-child(3) {
		animation-delay: -0.15s;
	}
	@keyframes lds-ring {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
  .buscando {
    font-size: 14px;
    color: #aaa;
  }
</style>
